/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { createContext } from "react";

const ClassDetailsContext = createContext({
  setWidthToClassCardDetails: (width: number) => {},
});

export default ClassDetailsContext;
